<template>
  <v-dialog :value="visiblePopup" persistent overlay-color='blue' fullscreen @keydown.esc="onCloseAddNewSPEmployeePopup">
    <div class='add-service-provider-employee-layout'>
      <div class="add-service-provider-employee-header">
        <span class="add-service-provider-employee-header-container">
          <div class="add-service-provider-employee-title d-inline-block">{{ $t('add.sp.employee.title') }}</div>
          <div class="cynergy-shield d-inline-block">
            <img src="../../assets/logo-no-text.svg" />
          </div>
          <span class="escape-link" @click="onCloseAddNewSPEmployeePopup()"> X {{ $t('edit.sp.employee.profile.esc') }} </span>
        </span>
      </div>
      <div class="content-area rectangle-area">
        <AddNewServiceProviderUserForm
          @certificationsChanged='certificationsInfoChanged'
          @servicesChanged='servicesInfoChanged'
          @generalInfoChanged='generalInfoChanged'
          @avatarChanged='avatarChanged'
          @saveNewUser='saveNewUser'
          :avatar='spWorkerAvatar'
          :certification-chosen-info='spWorkerCertificationsChosen'
          :services-chosen-info='spWorkerServicesChosen'
          :general-info='spWorkerGeneralInfo'/>
        <div class='save-new-service-provider-data'>
          <v-btn class='save-btn' @click='saveNewUser' :loading="loadingNext" :disabled='!saveEnabled'> {{ $t('add.sp.employee.form.save.button')}} </v-btn>
        </div>
      </div>
      <error-message :errorText="errorMessage" @close="errorMessage = ''" />
    </div>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import AddNewServiceProviderUserForm from '@/components/AddNewServiceProviderEmployee/AddNewServiceProviderUserForm.vue';
import {
  CHANGE_SP_WORKER_AVATAR,
  CHANGE_SP_WORKER_CHOSEN_CERTIFICATE,
  CHANGE_SP_WORKER_CHOSEN_SERVICES,
  CHANGE_SP_WORKER_GENERAL_INFO,
  REGISTER_SERVICE_PROVIDER_WORKER,
} from '@/store/spWorkerRegistration/actionTypes';
import ErrorMessage from '@/components/common/ErrorMessage.vue';

export default {
  name: 'AddNewServiceProviderEmployeeLayout',
  components: { AddNewServiceProviderUserForm, ErrorMessage },
  data() {
    return {
      saveEnabled: false,
      errorMessage: '',
      loadingNext: false,
    };
  },
  computed: {
    ...mapGetters([
      'spWorkerGeneralInfo',
      'spWorkerServicesChosen',
      'spWorkerCertificationsChosen',
      'spWorkerAvatar',
    ]),
  },
  props: {
    visiblePopup: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    async onCloseAddNewSPEmployeePopup() {
      await this.$emit('onCloseAddNewSPEmployeePopup', true);
    },
    async saveNewUser() {
      this.loadingNext = true;
      try {
        await this.$store.dispatch(REGISTER_SERVICE_PROVIDER_WORKER);
        this.$emit('onCloseAddNewSPEmployeePopup', true);
      } catch (e) {
        this.errorMessage = e.message;
        throw e;
      } finally {
        this.loadingNext = false;
      }
    },
    async avatarChanged(data) {
      await this.$store.dispatch(CHANGE_SP_WORKER_AVATAR, data);
    },
    async certificationsInfoChanged(data) {
      await this.$store.dispatch(CHANGE_SP_WORKER_CHOSEN_CERTIFICATE, data);
    },
    async servicesInfoChanged(data) {
      await this.$store.dispatch(CHANGE_SP_WORKER_CHOSEN_SERVICES, data);
    },
    async generalInfoChanged(data) {
      await this.$store.dispatch(CHANGE_SP_WORKER_GENERAL_INFO, data);
    },
  },
  watch: {
    spWorkerGeneralInfo: {
      handler() {
        this.saveEnabled = this.spWorkerGeneralInfo?.valid || false;
      },
      deep: true,
    },
  },
};
</script>

<style lang='scss'>
@import '~@/assets/styles/design-system';

.v-dialog {
  background-color: var(--bg-secondary);
}
</style>
<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.add-service-provider-employee-layout {
  height: fit-content;
  padding-bottom: 1%;
  display: flex;
  background-color: var(--bg-secondary);
}

.add-service-provider-employee-header {
  position: fixed;
  width: 100%;
  top: 0;
  background-color: var(--bg-secondary);
  z-index: 200;

  .add-service-provider-employee-header-container {
    width: $create-new-project-rectangle-container-width;
    margin: auto;
    padding-top: rem(14);
    display: flex;
  }
}

.add-service-provider-employee-title {
  width: 33%;
  color: var(--text-tertiary);
  font-family: $font-family-black;
  font-size: rem(20);
  font-weight: 900;
  letter-spacing: 0;
  text-align: left;
  padding-top: rem(10);
}

.cynergy-shield {
  width: 33%;
  text-align: center;

  img {
    max-height: rem(44);
  }
}

.escape-link {
  padding-left: 15%;
  display: inline-block;
  float: right;
  cursor: pointer;
  margin-left: rem(20);
  text-align: right;
  font-size: rem(12);
  text-transform: uppercase;
  text-decoration: none;
  padding-top: rem(20);
  height: rem(16);
  color: var(--text-secondary);
  font-family: $font-family-medium;
  font-weight: 500;
  letter-spacing: rem(1.1);
}

.rectangle-area {
  width: $create-new-project-rectangle-container-width;
  min-width: $create-new-project-rectangle-container-width;
  min-height: rem(716);
  border-radius: $radius-md;
  background-color: var(--bg-primary) !important;
  box-shadow: 0 0 rem(4) 0 rgba(14, 31, 51, 0.13);
  margin: auto;
  margin: rem(78) auto;
  .save-new-service-provider-data {
    display: flex;
    padding-left: rem(104);
    padding-right: rem(104);
    padding-top: 10%;
    padding-bottom: 10%;
    .save-btn {
      height: rem(32);
      border-radius: $radius-xs;
      background-color: var(--brand-primary) !important;
      box-shadow: 0 rem(1) rem(1) 0 #dbdbdb, 0 rem(2) rem(1) rem(-1) #e0e0e0, 0 rem(1) rem(3) 0 #cccccc !important;
      color: var(--text-inverse);
      font-size: rem(12);
      font-weight: 500;
      letter-spacing: rem(1.07);
      line-height: rem(16);
      text-align: center;
      margin-left: rem(8);
    }
  }
}
</style>
